export default function () {
	return {
		favorite: 'all',
		progress: 'all',
		search: '',
		loading: false,
		selected_areas: {
			value: 'all'
		},
		subscription_type: 'all',

		selected_groups: {
			value:'all'
		},

		selected_tags: {
			value:'all'
		}
	}
}
